import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import { Refresh as RefreshIcon, Sms as SmsIcon } from '@mui/icons-material';
import apiService from './Transactions/api';

const PAYBILL_NUMBER = '4093753';
const ACCOUNT_NUMBER = 'LiftPoa';

const formatCredit = (credit) =>
  Number(credit).toLocaleString('en-KE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const SmsBalance = () => {
  const [credit, setCredit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [rechargeOpen, setRechargeOpen] = useState(false);

  const loadBalance = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await apiService.getSmsBalance();
      setCredit(response.credit);
    } catch (err) {
      setCredit(null);
      setError(err.message || 'Could not fetch SMS balance');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadBalance();
  }, [loadBalance]);

  const renderBalance = () => {
    if (error) {
      return (
        <Tooltip title={error}>
          <Typography variant="body2" color="error" sx={{ fontWeight: 600 }}>
            Unavailable
          </Typography>
        </Tooltip>
      );
    }

    return (
      <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
        {credit === null ? '...' : formatCredit(credit)}
      </Typography>
    );
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <SmsIcon sx={{ color: '#1976d2', fontSize: 20 }} />
        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
          SMS Bal:
        </Typography>
        {renderBalance()}

        <Tooltip title="Refresh balance">
          <span>
            <IconButton
              size="small"
              onClick={loadBalance}
              disabled={loading}
              aria-label="Refresh SMS balance"
              sx={{ color: '#1976d2' }}
            >
              {loading ? <CircularProgress size={18} /> : <RefreshIcon fontSize="small" />}
            </IconButton>
          </span>
        </Tooltip>

        <Button
          size="small"
          variant="outlined"
          onClick={() => setRechargeOpen(true)}
          sx={{ textTransform: 'none' }}
        >
          Recharge
        </Button>
      </Box>

      <Dialog
        open={rechargeOpen}
        onClose={() => setRechargeOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Recharge SMS</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Pay using M-PESA with these details:
          </Typography>
          <Typography>
            Paybill: <strong>{PAYBILL_NUMBER}</strong>
          </Typography>
          <Typography>
            Account No: <strong>{ACCOUNT_NUMBER}</strong>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRechargeOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SmsBalance;